import { gql } from '@apollo/client';

export const UPLOAD_REPORTS_ZIP = gql`
  mutation uploadReportsZip($batchId: String!, $quizId: ID!, $zipFilename: String!) {
    uploadReportsZip(batchId: $batchId, quizId: $quizId, zipFilename: $zipFilename) {
      reportUrl
    }
  }
`;
